import Card from "components/card";
import { useDealData } from "contexts/DealContext";

const Notes = () => {
    const { currentDeal } = useDealData();

    const notes = currentDeal?.facilities?.["Consolidated"]?.details?.["Notes"]

    return (
        <Card extra={"justify-around w-full p-[16px] bg-cover flex flex-col"}>
            <h3 className="ml-4 mb-2 text-xl self-start font-bold text-gray-700 dark:text-white">
                Notes
            </h3>
            <div className="flex flex-col items-start justify-start px-5">
                {notes?.map((note, index) => (
                    <p key={index} className="text-base mb-1 text-gray-900 dark:text-white">
                        {note}
                    </p>
                ))}

            </div>
        </Card>
    );
};

export default Notes;